var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    {
      staticClass: "px-3",
      attrs: { toggleable: "md", type: "light", variant: "light" }
    },
    [
      _c("b-navbar-brand", { attrs: { to: { name: "BrandListClient" } } }, [
        _c("img", {
          attrs: {
            src: require("../../assets/Derco.gif"),
            width: "48",
            alt: ""
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-md-none ml-auto d-flex align-items-center" },
        [
          _c("span", { staticClass: "mobile-section-label mr-2" }, [
            _vm._v(_vm._s(_vm.currentMenuLabel))
          ]),
          _vm._v(" "),
          _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { "is-nav": "", id: "nav_collapse" } },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto d-md-none mobile-nav-list" },
            [
              _c("b-nav-item", { attrs: { to: { name: "BrandListClient" } } }, [
                _vm._v("Clientes x marca")
              ]),
              _vm._v(" "),
              _c(
                "b-nav-item",
                { attrs: { to: { name: "BrandListOffices" } } },
                [_vm._v("Oficinas por marca")]
              ),
              _vm._v(" "),
              _c("b-nav-item", { attrs: { to: { name: "BrandListModels" } } }, [
                _vm._v("Modelos por marca")
              ]),
              _vm._v(" "),
              _c("b-nav-item", { attrs: { to: { name: "BrandList" } } }, [
                _vm._v("Marcas")
              ]),
              _vm._v(" "),
              _c("b-nav-item", { attrs: { to: { name: "Contacts" } } }, [
                _vm._v("Contacto")
              ]),
              _vm._v(" "),
              _c("b-nav-item", { attrs: { to: { name: "TestDrives" } } }, [
                _vm._v("Test Drive")
              ]),
              _vm._v(" "),
              _c("b-nav-item", { attrs: { to: { name: "Auditoria" } } }, [
                _vm._v("Auditoría")
              ]),
              _vm._v(" "),
              _c("b-nav-item", { attrs: { to: { name: "Register" } } }, [
                _vm._v("Registrar")
              ]),
              _vm._v(" "),
              _c("b-nav-item", { attrs: { to: { name: "UsersList" } } }, [
                _vm._v("Usuarios")
              ]),
              _vm._v(" "),
              _c(
                "b-nav-item",
                {
                  staticClass: "mobile-logout",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.logout()
                    }
                  }
                },
                [_vm._v("Cerrar Sesión")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto d-none d-md-block" },
            [
              _c(
                "b-nav-item-dropdown",
                {
                  attrs: {
                    text: _vm.currentMenuLabel,
                    right: "",
                    "toggle-class": "nav-drop-custom",
                    "menu-class": "menu-dropdown"
                  }
                },
                [
                  _c(
                    "b-dropdown-item",
                    { attrs: { to: { name: "BrandListClient" } } },
                    [_vm._v("Clientes x marca")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    { attrs: { to: { name: "BrandListOffices" } } },
                    [_vm._v("Oficinas por marca")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    { attrs: { to: { name: "BrandListModels" } } },
                    [_vm._v("Modelos por marca")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    { attrs: { to: { name: "BrandList" } } },
                    [_vm._v("Marcas")]
                  ),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    { attrs: { to: { name: "Contacts" } } },
                    [_vm._v("Contacto")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    { attrs: { to: { name: "TestDrives" } } },
                    [_vm._v("Test Drive")]
                  ),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    { attrs: { to: { name: "Auditoria" } } },
                    [_vm._v("Auditoría")]
                  ),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    { attrs: { to: { name: "Register" } } },
                    [_vm._v("Registrar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-dropdown-item",
                    { attrs: { to: { name: "UsersList" } } },
                    [_vm._v("Usuarios")]
                  ),
                  _vm._v(" "),
                  _c("b-dropdown-divider"),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "logout-li",
                      attrs: { role: "presentation" }
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item dropdown-item-logout",
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.logout()
                            }
                          }
                        },
                        [_vm._v("\n            Cerrar Sesión\n          ")]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5658e598", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5658e598","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Supervisor/Header.vue
// module id = null
// module chunks = 